export default "__VITE_ASSET__f2517551__"